/* X Shoes — other colours of the same model (product page) */
(function(){
  var COL=new Set("black white grey gray red blue green pink purple yellow orange brown beige cream ivory sand silver gold metallic navy olive tan khaki burgundy maroon wine bordeaux cherry rose lilac lavender mauve violet plum fuchsia teal mint sage aqua turquoise coral peach salmon taupe stone bone chalk off triple all core cloud wonder crystal dark light pale bright deep royal sky ice icy frost glacier pearl alloy eclipse midnight ink fog smoke smokey ash charcoal graphite anthracite obsidian onyx jet carbon slate asphalt magnet wolf platinum chrome mocha coffee chocolate cacao espresso caramel camel cognac chestnut hickory sesame sail oatmeal oat natural nude linen ecru undyed vanilla milk snow arctic polar storm rain raincloud concrete cement shadow mushroom driftwood birch clay rust brick copper bronze lime limelight neon volt lemon apricot tangerine flame fire lumos dew iron rock moon fawn aurora surf wash lima mineral pear tempest ultramarine indigo denim chambray evergreen forest pine fir moss hemp gum preloved scarlet better collegiate halo putty magic leopard leaopard croc cow print floral glitter suede leather mesh patent velvet nubuck canvas pony multi multicolor colour color with and contrast stitching solar hyper crimson phantom apollo zodiac steel aloe grizzly mulberry pebble cinder raspberry orchid fade quartz lily heather granite oyster sea salt dust photon foam blush cinnamon dune desert earth strata clear spark semi true ultra pure double sweet baby powder pastel baige bige vert mole basalt thyme mocca chalky hazy night electric sneaker sneakers shoe shoes trainers".split(' '));
  var GEN=new Set('wmns womens mens women men woman man kids kid big gs ps td unisex w m'.split(' '));
  var DROP=new Set(['og','retro','the']);
  function words(t){
    t=String(t||'').replace(/\n/g,' ').toLowerCase().replace(/è/g,'e').replace(/é/g,'e').replace(/í/g,'i');
    t=t.replace(/[’‘`´]/g,"'").replace(/[“”"]/g,"'");
    t=t.replace(/\([^)]*\)/g,' ');
    t=t.replace(/'s\b/g,'s');
    t=t.replace(/'(\d\d)\b/g,' $1');
    return t;
  }
  function split(t){
    var model=t,colour='';
    var q=t.indexOf("'");
    if(q>-1){model=t.slice(0,q);colour=t.slice(q+1).replace(/'/g,' ');}
    else if(/\s[–—-]\s|\s[–—]|[–—]\s/.test(t)){var p=t.split(/\s*[–—]\s*|\s-\s/);model=p[0];colour=p.slice(1).join(' ');}
    return [model,colour];
  }
  function clean(t){
    t=t.replace(/\|/g,' ').replace(/\//g,' ').replace(/&/g,' ');
    t=t.replace(/[^a-z0-9 ]+/g,' ');
    t=t.replace(/\bon running\b/g,'on').replace(/\boncloud/g,'on cloud');
    t=t.replace(/\bair jordan\b/g,'jordan').replace(/\bqugg\b/g,'ugg');
    t=t.replace(/\b(cloud|x|loewe|sl|gel)(\d)/g,'$1 $2');
    t=t.replace(/\bsl 72\b/g,'sl72').replace(/\bsuper ?star\b/g,'superstar').replace(/\bair zoom vomero/g,'zoom vomero').replace(/\bchyper\b/g,'chypre').replace(/\bsandals\b/g,'sandal');
    t=t.replace(/\bcloud (solo|monster|nova|tilt|surfer|runner|vista|wander|flyer|stratus|boom|rock)\b/g,'cloud$1');
    return t;
  }
  function special(t){
    var c=clean(t);
    if(/\btriple stitch/.test(c)&&/\bzegna\b/.test(c))return /secondskin/.test(c)?'zegna triple stitch secondskin':'zegna triple stitch';
    if(/\btokyo mary jane\b/.test(c)&&/\badidas\b/.test(c))return 'adidas tokyo mary jane';
    return '';
  }
  function key(title){
    var sp=special(words(title));
    if(sp)return {k:sp,tk:sp.split(' '),rest:[]};
    var t=split(words(title))[0];
    var tk=clean(t).split(/\s+/).filter(function(w){return w&&!GEN.has(w)&&!DROP.has(w);});
    ['in','with'].forEach(function(c){var i=tk.indexOf(c,3);if(i>-1)tk=tk.slice(0,i);});
    var gone=[];
    while(tk.length>2&&COL.has(tk[tk.length-1]))gone.unshift(tk.pop());
    return {k:tk.join(' '),tk:tk,rest:gone};
  }
  function colourName(title){
    var w=words(title),s=split(w),k=key(title);
    var c=s[1]?s[1]:k.rest.join(' ');
    c=c.replace(/[|\/]/g,' ').replace(/\s+/g,' ').trim();
    return c.replace(/\b\w/g,function(m){return m.toUpperCase();});
  }
  var MW=new Set('waterproof wp gtx gore tex push coast pro max se sp lx ltd mid high hi low platform slipper slippers mule mules ballerina ballet sabot sd vintage xlg jane utility disrupt form void premium essential boot boots sandal sandals slide slides loafer loafers x lux next loewe advanced trail shaggy clog clogs sneakerina trainer runner skate tread oversized bouncing remix'.split(' '));
  function canon(k,keys){
    var best=k;
    keys.forEach(function(o){
      if(o.length<best.length&&k.indexOf(o+' ')===0){
        var nx=k.slice(o.length+1).split(' ')[0];
        if(o.split(' ').length>=2&&!MW.has(nx)&&!/\d/.test(nx))best=o;
      }
    });
    return best;
  }
  function query(K,title){
    var raw=' '+words(title).replace(/[^a-z0-9 ]+/g,' ').replace(/\s+/g,' ')+' ';
    var t=K.tk.filter(function(w){return raw.indexOf(' '+w+' ')>-1;});
    if(t.length<2)t=raw.trim().split(' ').filter(function(w){return !GEN.has(w);});
    var q=t.slice(0,2); if(t[2]&&/\d/.test(t[2]))q.push(t[2]);
    return q.join(' ');
  }

  window.XACW={key:function(t){return key(t).k;},colour:colourName,canon:canon,query:function(t){return query(key(t),t);},raw:function(t){return ' '+words(t).replace(/[^a-z0-9 ]+/g,' ').replace(/\s+/g,' ')+' ';}};
  if(typeof document==='undefined')return;

  function init(el){
    var title=el.getAttribute('data-title'),me=el.getAttribute('data-handle');
    var K=key(title); if(K.tk.length<2)return;
    var q=query(K,title);
    if(!q)return;
    var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'search?type=product&view=cw&q='+encodeURIComponent(q);
    var all=[],seen={};
    function page(n){
      return fetch(base+'&page='+n,{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(tx){
        var d=JSON.parse(tx);
        d.r.forEach(function(p){ if(!seen[p.h]){seen[p.h]=1;p.k=key(p.t).k;all.push(p);} });
        if(n<d.p&&n<8)return page(n+1);
      });
    }
    page(1).then(function(){
      var keys=[];all.forEach(function(p){if(keys.indexOf(p.k)<0)keys.push(p.k);});
      if(keys.indexOf(K.k)<0)keys.push(K.k);
      var mine=canon(K.k,keys);
      var out=all.filter(function(p){return canon(p.k,keys)===mine;});
      if(out.length<2)return;
      out.sort(function(a,b){return (b.h===me)-(a.h===me)||(b.a-a.a);});
      var row=el.querySelector('[data-cw-row]'),cur=el.querySelector('[data-cw-cur]'),cnt=el.querySelector('[data-cw-n]');
      cur.textContent=colourName(title);
      cnt.textContent=out.length+' colours';
      var lim=el.getAttribute('data-limit')|0||11;
      row.innerHTML=out.map(function(p,i){
        var c=colourName(p.t);
        return '<a href="'+p.u+'"'+(p.h===me?' class="is-on" aria-current="true"':'')+(p.a?'':' data-so')+(i>=lim?' data-x':'')+' title="'+c.replace(/"/g,'&quot;')+'" aria-label="'+c.replace(/"/g,'&quot;')+'">'+(p.i?'<img src="'+p.i+'" alt="" loading="lazy" width="120" height="120">':'')+'</a>';
      }).join('')+(out.length>lim?'<button type="button" class="xa-cw__more" data-cw-more>+'+(out.length-lim)+'</button>':'');
      var more=row.querySelector('[data-cw-more]');
      if(more)more.addEventListener('click',function(){el.classList.add('is-all');more.remove();});
      row.addEventListener('mouseover',function(e){var a=e.target.closest('a');if(a)cur.textContent=a.title;});
      row.addEventListener('mouseleave',function(){cur.textContent=colourName(title);});
      el.hidden=false;
    }).catch(function(){});
  }
  function boot(){document.querySelectorAll('[data-xa-cw]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
